// extracted by mini-css-extract-plugin
module.exports = {"Page":"ManagerDiscoveryCategories_Page__3xKpd","NameGroup":"ManagerDiscoveryCategories_NameGroup__l0OTr"};